module.exports = __webpack_public_path__ + "static/media/start-carousel-capture.00c1948d.jpg";